module.exports = __webpack_public_path__ + "img/sec_img3.a7da3778.png";